import Immutable from 'immutable';
import FinesConstants from '../../constants/FinesConstants';
import BorrowingConstants from '../../constants/BorrowingConstants';
import _ from 'lodash';

const {
  FETCH_FINES_REQUEST,
  FETCH_FINES_SUCCESS,
  FETCH_FINES_FAILURE,
  FETCH_FINES_PAYMENT_FORM_SUCCESS,
  FETCH_FINES_PAYMENT_FORM_FAILURE,
  UPDATE_PAGE_REQUEST,
  UPDATE_PAGE_SUCCESS,
  UPDATE_PAGE_FAILURE
} = FinesConstants;

const initialState = Immutable.Map({
  results: Immutable.List()
});

export default function finesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FINES_SUCCESS: {
      return state.mergeDeep(action.payload.borrowing)
        .set('results', Immutable.fromJS(action.payload.borrowing.fines.results))
        .set('isFetching', false);
    }

    case FETCH_FINES_PAYMENT_FORM_SUCCESS:
    case FETCH_FINES_PAYMENT_FORM_FAILURE: {
      return state.mergeDeep(action.payload.borrowing).set('isFetching', false);
    }

    case FETCH_FINES_REQUEST:
    case UPDATE_PAGE_REQUEST: {
      return state.set('isFetching', true);
    }

    case UPDATE_PAGE_SUCCESS: {
      return state
        .mergeDeep(action.payload.borrowing)
        .set('results', Immutable.fromJS(action.payload.borrowing.fines.results))
        .set('isFetching', false);
    }

    case FETCH_FINES_FAILURE:
    case UPDATE_PAGE_FAILURE: {
      return state.set('isFetching', false);
    }

    case BorrowingConstants.FETCH_SUMMARIES_SUCCESS: {
      return state.mergeDeep(_.get(action, 'payload.borrowing', {}));
    }


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/borrowing/FinesReducer.js